import { useState } from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'
import './Payments.css'

const paymentsData = {
  overview: {
    todayRevenue: '$2,847.00',
    todayTransactions: 23,
    weekRevenue: '$18,429.00',
    weekTransactions: 142,
    monthRevenue: '$48,291.00',
    monthTransactions: 421,
    pendingPayouts: '$12,840.00'
  },
  recentTransactions: [
    { id: 'TXN-0892', customer: 'Widget Co', email: 'billing@widgetco.com', amount: 450.00, status: 'completed', date: 'Today, 10:42 AM', method: 'card' },
    { id: 'TXN-0891', customer: 'Acme Industries', email: 'ap@acme.com', amount: 1250.00, status: 'completed', date: 'Today, 10:15 AM', method: 'card' },
    { id: 'TXN-0890', customer: 'Tech Solutions', email: 'finance@techsol.io', amount: 89.00, status: 'completed', date: 'Today, 09:30 AM', method: 'card' },
    { id: 'TXN-0889', customer: 'StartupXYZ', email: 'hello@startupxyz.com', amount: 299.00, status: 'pending', date: 'Yesterday', method: 'bank' },
    { id: 'TXN-0888', customer: 'Global Corp', email: 'payments@globalcorp.com', amount: 2400.00, status: 'completed', date: 'Yesterday', method: 'card' }
  ],
  topCustomers: [
    { name: 'Global Corp', revenue: '$12,450.00', transactions: 8 },
    { name: 'Acme Industries', revenue: '$8,920.00', transactions: 12 },
    { name: 'Tech Solutions', revenue: '$5,420.00', transactions: 45 },
    { name: 'Widget Co', revenue: '$3,280.00', transactions: 6 }
  ]
}

function PaymentsDashboard() {
  return (
    <div className="payments-dashboard">
      {/* Stats Grid */}
      <div className="stats-grid">
        <div className="stat-card">
          <span className="stat-label">Today's Revenue</span>
          <span className="stat-value">{paymentsData.overview.todayRevenue}</span>
          <span className="stat-sub">{paymentsData.overview.todayTransactions} transactions</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">This Week</span>
          <span className="stat-value">{paymentsData.overview.weekRevenue}</span>
          <span className="stat-sub">{paymentsData.overview.weekTransactions} transactions</span>
        </div>
        <div className="stat-card">
          <span className="stat-label">This Month</span>
          <span className="stat-value">{paymentsData.overview.monthRevenue}</span>
          <span className="stat-sub">{paymentsData.overview.monthTransactions} transactions</span>
        </div>
        <div className="stat-card highlight">
          <span className="stat-label">Pending Payouts</span>
          <span className="stat-value">{paymentsData.overview.pendingPayouts}</span>
          <Link to="/dashboard/payments/payouts" className="stat-link">View payouts →</Link>
        </div>
      </div>

      {/* Chart Placeholder */}
      <div className="chart-section">
        <div className="section-header">
          <h2 className="section-title">Revenue Over Time</h2>
          <div className="chart-controls">
            <button className="chart-btn active">7 days</button>
            <button className="chart-btn">30 days</button>
            <button className="chart-btn">90 days</button>
          </div>
        </div>
        <div className="chart-placeholder">
          <svg viewBox="0 0 800 200" className="chart-svg">
            <defs>
              <linearGradient id="chartGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="rgba(59, 130, 246, 0.3)"/>
                <stop offset="100%" stopColor="rgba(59, 130, 246, 0)"/>
              </linearGradient>
            </defs>
            <path 
              d="M0,180 Q100,160 200,140 T400,100 T600,80 T800,60" 
              fill="none" 
              stroke="var(--color-payments)" 
              strokeWidth="2"
            />
            <path 
              d="M0,180 Q100,160 200,140 T400,100 T600,80 T800,60 L800,200 L0,200 Z" 
              fill="url(#chartGradient)"
            />
          </svg>
        </div>
      </div>

      {/* Two Column Layout */}
      <div className="payments-grid">
        {/* Recent Transactions */}
        <div className="transactions-section">
          <div className="section-header">
            <h2 className="section-title">Recent Transactions</h2>
            <Link to="/dashboard/payments/transactions" className="section-link">View all</Link>
          </div>
          <div className="transactions-list">
            {paymentsData.recentTransactions.map(txn => (
              <div key={txn.id} className="transaction-item">
                <div className="txn-info">
                  <span className="txn-customer">{txn.customer}</span>
                  <span className="txn-id">{txn.id}</span>
                </div>
                <div className="txn-amount">
                  <span className="amount">${txn.amount.toFixed(2)}</span>
                  <span className={`txn-status ${txn.status}`}>{txn.status}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Top Customers */}
        <div className="customers-section">
          <div className="section-header">
            <h2 className="section-title">Top Customers</h2>
            <Link to="/dashboard/payments/customers" className="section-link">View all</Link>
          </div>
          <div className="customers-list">
            {paymentsData.topCustomers.map((customer, idx) => (
              <div key={idx} className="customer-item">
                <div className="customer-rank">{idx + 1}</div>
                <div className="customer-info">
                  <span className="customer-name">{customer.name}</span>
                  <span className="customer-txns">{customer.transactions} transactions</span>
                </div>
                <span className="customer-revenue">{customer.revenue}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="quick-actions">
        <h2 className="section-title">Quick Actions</h2>
        <div className="actions-grid">
          <button className="action-card">
            <div className="action-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="12" y1="5" x2="12" y2="19"/>
                <line x1="5" y1="12" x2="19" y2="12"/>
              </svg>
            </div>
            <span className="action-label">Create checkout</span>
          </button>
          <button className="action-card">
            <div className="action-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
              </svg>
            </div>
            <span className="action-label">Send invoice</span>
          </button>
          <button className="action-card">
            <div className="action-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="8.5" cy="7" r="4"/>
                <line x1="20" y1="8" x2="20" y2="14"/>
                <line x1="23" y1="11" x2="17" y2="11"/>
              </svg>
            </div>
            <span className="action-label">Add customer</span>
          </button>
          <button className="action-card">
            <div className="action-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
            </div>
            <span className="action-label">Export data</span>
          </button>
        </div>
      </div>
    </div>
  )
}

function Payments() {
  const location = useLocation()
  const isOverview = location.pathname === '/dashboard/payments'

  const subRoutes = [
    { name: 'Overview', path: '/dashboard/payments', end: true },
    { name: 'Transactions', path: '/dashboard/payments/transactions' },
    { name: 'Checkouts', path: '/dashboard/payments/checkouts' },
    { name: 'Payouts', path: '/dashboard/payments/payouts' },
    { name: 'Customers', path: '/dashboard/payments/customers' }
  ]

  return (
    <div className="payments-page">
      {/* Header */}
      <div className="page-header">
        <div className="header-info">
          <div className="module-badge payments">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="1" y="4" width="22" height="16" rx="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
          </div>
          <div>
            <h1 className="page-title">Payments</h1>
            <p className="page-subtitle">Chekkouts · Accept payments and manage transactions</p>
          </div>
        </div>
        <div className="header-actions">
          <button className="btn btn-secondary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4"/>
            </svg>
            Settings
          </button>
          <button className="btn btn-primary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            New checkout
          </button>
        </div>
      </div>

      {/* Sub Navigation */}
      <nav className="sub-nav">
        {subRoutes.map(route => (
          <NavLink 
            key={route.path} 
            to={route.path} 
            end={route.end}
            className={({ isActive }) => `sub-nav-link ${isActive ? 'active' : ''}`}
          >
            {route.name}
          </NavLink>
        ))}
      </nav>

      {/* Content */}
      {isOverview ? <PaymentsDashboard /> : <Outlet />}
    </div>
  )
}

export default Payments
